import type { PedigreeType } from '@application/types';
import type { AnimalSizeEnum, CountryCode } from '@gql/graphql';
import type {
  BreedOverviewData,
  CardItemBreederData,
  CardItemLitterData,
  FiltersWithModalData,
  PromoNewsletterData,
  SelectOption,
  StoreCardItemPromoData,
} from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler, ReactNode } from 'react';

export enum LitterListSortType {
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  DATE_ASC = 'DATE_ASC',
  DATE_DESC = 'DATE_DESC',
  RATING_ASC = 'RATING_ASC',
  RATING_DESC = 'RATING_DESC',
}

export interface LitterListPageFormOptions {
  breeds: SelectOption<string>[];
  regions: SelectOption<string>[];
  price: { limit: [number, number] };
}

export interface LitterListPageBreederCategory {
  label: string;
  breeders?: CardItemBreederData[];
  canLoadMoreRelatedBreeders?: boolean;
  link?: LocationDescriptor;
}

export interface LitterListPageFormValues {
  // sortBy?: LitterListSortType;
  sizeIds?: AnimalSizeEnum[];
  breedNames?: string[];
  born?: boolean;
  price?: [number, number];
  pedigree?: PedigreeType[];
  spokenLanguages?: string[];
  countries?: CountryCode[];
  regions?: string[];
}

export interface LitterListPageProps {
  items: (CardItemLitterData | StoreCardItemPromoData)[];
  currentPage: number;
  formOptions: LitterListPageFormOptions;

  newsletter?: PromoNewsletterData;
  breederCategories?: LitterListPageBreederCategory[];
  loading?: boolean;

  loadMoreLoading?: boolean;
  onLoadMoreClick?: MouseEventHandler;
  loadMoreText?: string;
  canLoadMore?: boolean;

  filtersModal: FiltersWithModalData;
  pageTitle: string;

  breedOverview?: BreedOverviewData;
  breedInteretBanner?: ReactNode;
}
